import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserRoleService } from '../services/user-role.service';

export const allowNonRestrictedRoleGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userRoleService = inject(UserRoleService);

  return userRoleService.shouldRestrictFeatures()
    ? router.createUrlTree([''])
    : true;
};
